import { Box, InputBase } from '@mui/material'
import { YALO_RADIUS, YALO_SEMANTIC } from '@commerce/tokens'

/** The design's magnifier, stroke-drawn like its other icons. */
const SearchIcon = () => (
  <Box
    component="svg"
    aria-hidden
    sx={{ width: 17, height: 17, flex: 'none', color: YALO_SEMANTIC.fg3 }}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
  >
    <circle cx="11" cy="11" r="7" />
    <path d="m20 20-3.5-3.5" />
  </Box>
)

/**
 * The search pill at the top of the home scroll.
 *
 * The design draws it as a static decoration; here it is a real `type="search"`
 * input (which is also what puts the native clear affordance on it) whose value
 * the page owns.
 *
 * It used to ship with `searchCatalog`, a client-side matcher over the models
 * already on screen. That is gone: matching now happens in `search` on the
 * server (`useCatalogBrowse`), so a product on page four is findable. A local
 * matcher kept alongside it would be a second, quieter answer to the same
 * question — and the one that disagreed would be the one the shopper saw first.
 */
export const CatalogSearch = ({
  value,
  onChange,
}: {
  value: string
  onChange: (next: string) => void
}) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      gap: 1.25,
      height: 46,
      px: 2,
      bgcolor: YALO_SEMANTIC.bgSurface,
      border: `1px solid ${YALO_SEMANTIC.borderDefault}`,
      borderRadius: `${YALO_RADIUS.pill}px`,
    }}
  >
    <SearchIcon />
    <InputBase
      type="search"
      value={value}
      onChange={(event) => onChange(event.target.value)}
      placeholder="Buscar productos"
      inputProps={{ 'aria-label': 'Buscar productos' }}
      sx={{ flex: 1, fontSize: 14.5 }}
    />
  </Box>
)
